export const GET_KMS_TAXONOMY_OPTIONS_REQUEST = "GET_KMS_TAXONOMY_OPTIONS_REQUEST";
export const GET_KMS_TAXONOMY_OPTIONS_SUCCESS = "GET_KMS_TAXONOMY_OPTIONS_SUCCESS";
export const GET_KMS_TAXONOMY_OPTIONS_FAIL = "GET_KMS_TAXONOMY_OPTIONS_FAIL";

export const GET_KMS_CATEGORIES_REQUEST = "GET_KMS_CATEGORIES_REQUEST";
export const GET_KMS_CATEGORIES_SUCCESS = "GET_KMS_CATEGORIES_SUCCESS";
export const GET_KMS_CATEGORIES_FAIL = "GET_KMS_CATEGORIES_FAIL";

export const CREATE_KMS_CATEGORY_REQUEST = "CREATE_KMS_CATEGORY_REQUEST";
export const UPDATE_KMS_CATEGORY_REQUEST = "UPDATE_KMS_CATEGORY_REQUEST";
export const TOGGLE_KMS_CATEGORY_ACTIVE_REQUEST = "TOGGLE_KMS_CATEGORY_ACTIVE_REQUEST";
export const DELETE_KMS_CATEGORY_REQUEST = "DELETE_KMS_CATEGORY_REQUEST";

export const GET_KMS_TAGS_REQUEST = "GET_KMS_TAGS_REQUEST";
export const GET_KMS_TAGS_SUCCESS = "GET_KMS_TAGS_SUCCESS";
export const GET_KMS_TAGS_FAIL = "GET_KMS_TAGS_FAIL";

export const CREATE_KMS_TAG_REQUEST = "CREATE_KMS_TAG_REQUEST";
export const UPDATE_KMS_TAG_REQUEST = "UPDATE_KMS_TAG_REQUEST";
export const DELETE_KMS_TAG_REQUEST = "DELETE_KMS_TAG_REQUEST";

export const SET_KMS_TAXONOMY_LOADING = "SET_KMS_TAXONOMY_LOADING";
export const SET_KMS_TAXONOMY_SAVING = "SET_KMS_TAXONOMY_SAVING";
export const CLEAR_KMS_TAXONOMY_ERROR = "CLEAR_KMS_TAXONOMY_ERROR";
export const CLEAR_KMS_TAXONOMY_MESSAGE = "CLEAR_KMS_TAXONOMY_MESSAGE";

export const getKmsTaxonomyOptionsRequest = () => ({
    type: GET_KMS_TAXONOMY_OPTIONS_REQUEST,
});

export const getKmsTaxonomyOptionsSuccess = (payload) => ({
    type: GET_KMS_TAXONOMY_OPTIONS_SUCCESS,
    payload,
});

export const getKmsTaxonomyOptionsFail = (error) => ({
    type: GET_KMS_TAXONOMY_OPTIONS_FAIL,
    error,
});

export const getKmsCategoriesRequest = (activeOnly) => ({
    type: GET_KMS_CATEGORIES_REQUEST,
    payload: { activeOnly },
});

export const getKmsCategoriesSuccess = (payload) => ({
    type: GET_KMS_CATEGORIES_SUCCESS,
    payload,
});

export const getKmsCategoriesFail = (error) => ({
    type: GET_KMS_CATEGORIES_FAIL,
    error,
});

export const createKmsCategoryRequest = (data) => ({
    type: CREATE_KMS_CATEGORY_REQUEST,
    payload: data,
});

export const updateKmsCategoryRequest = (id, data) => ({
    type: UPDATE_KMS_CATEGORY_REQUEST,
    payload: { id, data },
});

export const toggleKmsCategoryActiveRequest = (id, active) => ({
    type: TOGGLE_KMS_CATEGORY_ACTIVE_REQUEST,
    payload: { id, active },
});

export const deleteKmsCategoryRequest = (id) => ({
    type: DELETE_KMS_CATEGORY_REQUEST,
    payload: { id },
});

export const getKmsTagsRequest = () => ({
    type: GET_KMS_TAGS_REQUEST,
});

export const getKmsTagsSuccess = (payload) => ({
    type: GET_KMS_TAGS_SUCCESS,
    payload,
});

export const getKmsTagsFail = (error) => ({
    type: GET_KMS_TAGS_FAIL,
    error,
});

export const createKmsTagRequest = (data) => ({
    type: CREATE_KMS_TAG_REQUEST,
    payload: data,
});

export const updateKmsTagRequest = (id, data) => ({
    type: UPDATE_KMS_TAG_REQUEST,
    payload: { id, data },
});

export const deleteKmsTagRequest = (id) => ({
    type: DELETE_KMS_TAG_REQUEST,
    payload: { id },
});

export const setKmsTaxonomyLoading = (loading) => ({
    type: SET_KMS_TAXONOMY_LOADING,
    payload: loading,
});

export const setKmsTaxonomySaving = (loading) => ({
    type: SET_KMS_TAXONOMY_SAVING,
    payload: loading,
});

export const clearKmsTaxonomyError = () => ({
    type: CLEAR_KMS_TAXONOMY_ERROR,
});

export const clearKmsTaxonomyMessage = () => ({
    type: CLEAR_KMS_TAXONOMY_MESSAGE,
});
